import React, { Component } from "react";
import PropTypes from "prop-types";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage, injectIntl } from "react-intl";
import * as _ from "lodash-es";
import "./OwDateRange.scss";

import enUS from "date-fns/locale/en-US";
import enGB from "date-fns/locale/en-GB";
import de from "date-fns/locale/de";
import moment, { Moment } from "moment-timezone";
import OwLabel from "../OwLabel/OwLabel";
registerLocale("en-GB", enGB);
registerLocale("en-US", enUS);
registerLocale("de", de);

type Props = {
    disabled?: boolean;
    className?: string;
    startDateSelected?: Date | null;
    endDateSelected?: Date | null;
    startFn: (date: Moment | null) => void;
    endFn: (date: Moment | null) => void;
    intl: any;
    startDateTitle?: string;
    endDateTitle?: string;
    topDateWrapperClassName?: string;
    bottomDateWrapperClassName?: string;
    startLabel?: string;
    endLabel?: string;
    startLabelClassName?: string;
    endLabelClassName?: string;
    minStartDate?: Date | null;
};

type State = {
    startDateSelected?: Date;
    endDateSelected?: Date;
};

class OwDateRange extends Component<Props, State> {
    locale = this.props.intl.locale;

    static defaultProps = {
        disabled: false,
    };

    readonly state: State = {
        startDateSelected: undefined,
        endDateSelected: undefined,
    };

    startFn = (date: Date) => {
        const startDateSelected = date;

        this.setState(
            {
                startDateSelected,
            },
            () => {
                this.props.startFn(this.state.startDateSelected ? moment(this.state.startDateSelected) : null);
            }
        );
    };

    endFn = (date: Date) => {
        this.setState(
            {
                endDateSelected: date,
            },
            () => {
                this.props.endFn(this.state.endDateSelected ? moment(this.state.endDateSelected) : null);
            }
        );
    };

    render() {
        let startDateSelected = _.get(this.props, "startDateSelected", this.state.startDateSelected);
        let endDateSelected = _.get(this.props, "endDateSelected", this.state.endDateSelected);

        if (startDateSelected && moment.isMoment(startDateSelected)) {
            startDateSelected = startDateSelected.toDate();
        }

        if (endDateSelected && moment.isMoment(endDateSelected)) {
            endDateSelected = endDateSelected.toDate();
        }

        if (startDateSelected && endDateSelected) {
            if (moment(startDateSelected).isAfter(endDateSelected)) {
                endDateSelected = undefined;
            }

            if (moment(endDateSelected!).isBefore(startDateSelected)) {
                startDateSelected = undefined;
            }
        }

        return (
            <div className={"OwDateRange d-flex flex-wrap " + this.props.className}>
                <div className={"d-inline-flex col-12 col-md-auto ps-0 pe-0 " + this.props.topDateWrapperClassName}>
                    {this.props.startLabel ? (
                        <OwLabel title={this.props.startLabel} isBold={true} className={this.props.startLabelClassName ?? "me-1 w-3r"} />
                    ) : null}
                    <div className={"input-group me-md-2 w-100"}>
                        <DatePicker
                            title={this.props.startDateTitle || "start date"}
                            locale={this.locale}
                            className="d-inline-flex form-control form-control-sm rounded-end-0"
                            selectsStart
                            selected={startDateSelected}
                            startDate={startDateSelected}
                            endDate={endDateSelected}
                            dateFormat="yyyy-MM-dd"
                            onSelect={this.startFn}
                            onChange={this.startFn}
                            disabled={this.props.disabled}
                            minDate={this.props.minStartDate}
                            portalId="root"
                        />
                        <i className={"input-group-text fas fa-calendar-alt"} />
                    </div>
                </div>

                <div className={"d-inline-flex col-12 col-md-auto ps-0 pe-0 " + this.props.bottomDateWrapperClassName}>
                    {this.props.endLabel ? (
                        <OwLabel title={this.props.endLabel} isBold={true} className={this.props.endLabelClassName ?? "me-1 w-3r"} />
                    ) : null}
                    <div className={"input-group me-md-2 mt-2 mt-md-0 w-100"}>
                        <DatePicker
                            title={this.props.endDateTitle || "end date"}
                            locale={this.locale}
                            className="d-inline-flex form-control form-control-sm rounded-end-0"
                            selected={endDateSelected}
                            selectsEnd
                            startDate={startDateSelected}
                            endDate={endDateSelected}
                            dateFormat="yyyy-MM-dd"
                            onSelect={this.endFn}
                            onChange={this.endFn}
                            disabled={this.props.disabled}
                            portalId="root"
                        />
                        <i className={"input-group-text fas fa-calendar-alt"} />
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(OwDateRange);
